module.exports = __webpack_public_path__ + "img/page-load-1.gif";


//////////////////
// WEBPACK FOOTER
// ./resources/views/partials/index/loader/img/page-load-1.gif
// module id = 58
// module chunks = 0